import { Reveal } from "../components/Reveal";
import { SERVICES } from "../data/content";
import { MessagesSquare, Truck, Hammer, Sparkles, ShieldCheck, AudioLines, ArrowRight } from "lucide-react";

const ICONS = { MessagesSquare, Truck, Hammer, Sparkles, ShieldCheck, AudioLines };

export const Services = () => (
  <section data-testid="services-section" id="leistungen-overview" className="py-20 lg:py-32 bg-white border-y border-[#E5E0D8]">
    <div className="container-blum">
      <div className="max-w-3xl mx-auto text-center">
        <Reveal><p className="overline">Leistungen</p></Reveal>
        <Reveal delay={0.05}>
          <h2 className="text-3xl lg:text-4xl font-bold tracking-tight mt-4 leading-tight">
            Vom ersten Beratungsgespräch bis zur fertigen Fläche – alles aus einer Hand.
          </h2>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mt-14">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <Reveal key={s.title} delay={i * 0.06}>
              <div data-testid={`service-card-${i}`} className="lift bg-[#F9F8F6] border border-[#E5E0D8] p-8 h-full group text-center">
                <div className="flex items-center justify-center gap-3 mb-4">
                  <span className="w-12 h-12 flex items-center justify-center bg-[#2B2B30] text-white shrink-0 group-hover:bg-[#D32F2F] transition-colors">
                    <Icon className="w-6 h-6" strokeWidth={1.6} />
                  </span>
                  <h3 className="font-display text-xl font-semibold text-[#2B2B30]">{s.title}</h3>
                </div>
                <p className="text-[#6B6B73] leading-relaxed text-justify">{s.text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>

      <Reveal delay={0.1}>
        <div className="mt-12 text-center">
          <a href="/leistungen" data-testid="services-more-link" className="inline-flex items-center gap-2 font-display font-semibold text-lg text-[#D32F2F] hover:gap-3 transition-all">
            Alle Leistungen im Detail <ArrowRight className="w-5 h-5" />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
